import { Calendar, DollarSign, Hash, Percent, Type } from "lucide-react";
import type { ReactNode } from "react";
import {
  AI_SPREADSHEET_VALUE_TYPE,
  type AiSpreadsheetValueType,
} from "@/payroll/ai-script/types";

interface CellFormatOption {
  value: AiSpreadsheetValueType;
  label: string;
  icon: ReactNode;
}

export const CELL_FORMAT_OPTIONS: CellFormatOption[] = [
  {
    value: AI_SPREADSHEET_VALUE_TYPE.currency,
    label: "Currency",
    icon: <DollarSign className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.percent,
    label: "Percent",
    icon: <Percent className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.number,
    label: "Number",
    icon: <Hash className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.text,
    label: "Text",
    icon: <Type className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.date,
    label: "Date",
    icon: <Calendar className="h-3.5 w-3.5" />,
  },
];
